import {
  Button,
  Image,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { nFormatter } from "../../../components/profile/ProfileOverview";
import { useGetState } from "../../../context/useGetState";
import { photoBaseURL } from "../../../service/api";
import thelogo from "../../../assets/thelogo.png";

function Profile() {
  const modeBg = useColorModeValue("#fff", "#030c1b");
  const modeBoxShadow = useColorModeValue("#80808024", "#030c1b");
  const textColor1 = useColorModeValue("#11243D", "#fff");
  const editBgColor = useColorModeValue("transparent", "#fff");
  const editTextColor = useColorModeValue("#000", "#000");
  const { state } = useGetState();
  const userInfo = state?.userInfo;
  const navigate = useNavigate();

  return (
    <Stack
      alignItems={"center"}
      flex="2.2"
      borderRadius="15px"
      boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
      p="15px 5px"
      bg={modeBg}
      maxW={["100%", "250px"]}
      spacing="10px"
      textAlign={"center"}
    >
      <Image
        borderRadius={"15px"}
        w="60px"
        h="60px"
        maxH="60px"
        maxW="60px"
        objectFit={"cover"}
        fallbackSrc={thelogo}
        src={userInfo?.picture}
        alt="profile user pic"
      />
      <Stack spacing={"-0.5"}>
        <Text fontWeight={"bold"} color={textColor1} fontSize={"1.1em"}>
          {userInfo?.username}
        </Text>
        <Text color="#707A89" fontSize={".7em"}>
          {userInfo?.profession}
        </Text>
      </Stack>
      <Stack direction={"row"} alignItems="center" spacing={"20px"}>
        <Stack spacing={"-1"}>
          <Text color={textColor1} fontWeight={"bold"}>
            {nFormatter(userInfo?.total_followers)}
          </Text>
          <Text color="#707A89" fontSize={".7em"}>
            {/* Investors */}
            Followers
          </Text>
        </Stack>
        <Stack spacing={"-1"}>
          <Text color={textColor1} fontWeight={"bold"}>
            {nFormatter(userInfo?.total_following)}
          </Text>
          <Text color="#707A89" fontSize={".7em"}>
            {/* Mentors */}
            Following
          </Text>
        </Stack>
        <Stack spacing={"-1"}>
          <Text color={textColor1} fontWeight={"bold"}>
            {userInfo?.total_post || 0}
          </Text>
          <Text color="#707A89" fontSize={".7em"}>
            Posts
          </Text>
        </Stack>
      </Stack>
      <Stack direction={"row"} alignItems="center">
        <Button
          size="sm"
          bg="#4F46BA"
          color="#fff"
          w="80px"
          h="25px"
          fontSize={".8em"}
          fontWeight="300"
          borderRadius="8px"
          onClick={() => navigate("/profile")}
        >
          View Profile
        </Button>
        <Button
          size="sm"
          bg={editBgColor}
          color={editTextColor}
          border="1px solid #E6E6EB"
          w="80px"
          h="25px"
          fontSize={".8em"}
          fontWeight="300"
          borderRadius="8px"
          onClick={() => navigate("/profile")}
        >
          Edit{" "}
        </Button>
      </Stack>

      <SimpleGrid
        columns={[2, null, 3]}
        spacing="1px"
        borderRadius={"15px"}
        overflow="hidden"
      >
        {userInfo?.posts?.map((data) => {
          return (
            <Image
              w="70px"
              h="70px"
              maxH={"70px"}
              maxW={"70px"}
              objectFit={"cover"}
              src={`${photoBaseURL}${data?.file}`}
              alt="profile user pic"
              fallbackSrc="https://via.placeholder.com/150"
            />
          );
        })}
      </SimpleGrid>
    </Stack>
  );
}

export default Profile;
